import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from '@shared/models/app-config.model';
import { Constants } from '@shared/services/constants';
import { Constant } from '@shared/utilities/constant';
import { MemberCodeValidationResponseModel } from '@shared/models/member-sign-up.model';

@Injectable()
export class SignUpService {
    constructor(private http: HttpClient, 
        @Inject(Constant.appConfig) private appConfig: AppConfig,
        private _http: HttpClient) { }
  
    private headers: HttpHeaders;

    public getMemberCodeValidate(codeVal: string,dob:string,clientCode:string): Observable<MemberCodeValidationResponseModel> {
        let url = `${this.appConfig.apiBaseUrl}${Constants.id4.getMemberCodeValidateData}?RegCode=${codeVal}&memberDOB=${dob}&clientCode=${clientCode}`;
        return this._http.get<MemberCodeValidationResponseModel>(url);
    }

}